import { Edit } from 'react-admin';
import { ChangeUserForm } from '../../../../widgets/ChangeUserForm/ui/ChangeUserForm';

export const UserEdit = () => (
  <Edit>
    <ChangeUserForm />
  </Edit>
);
